var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteProfileSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8005 24.1613C24.8005 25.4895 24.2042 26.4331 23.2551 27.1015C21.3056 28.4747 17.8678 28.6868 15.0541 28.6868L14.7547 28.6866C12.0894 28.6801 5.30518 28.5118 5.30518 24.1367C5.30518 20.1628 10.6447 19.6318 14.7962 19.6117L15.3535 19.6114C16.3027 19.6137 17.7742 19.6365 19.2755 19.8627C21.9893 20.2714 24.8005 21.3444 24.8005 24.1613ZM15.0541 21.4573C9.80979 21.4573 7.15133 22.3582 7.15133 24.1367C7.15133 25.9311 9.80979 27.9233 15.0541 27.9233C18.5666 27.9233 20.9186 26.4363 22.0885 25.6347C22.6649 25.2397 22.9544 24.7483 22.9544 24.1613C22.9544 22.8559 21.5483 22.0188 18.7634 21.6595C17.7201 21.5249 16.4831 21.4573 15.0541 21.4573ZM15.0541 4.23096C18.6578 4.23096 21.5882 7.16265 21.5882 10.7663C21.5882 14.37 18.6578 17.3005 15.0541 17.3005H15.0147C11.4184 17.2894 8.50517 14.3565 8.51744 10.7626C8.51744 7.16265 11.4492 4.23096 15.0541 4.23096ZM15.0541 5.98849C12.419 5.98849 10.275 8.13126 10.275 10.7663C10.2664 13.3928 12.3944 15.5343 15.0184 15.5442L15.0541 16.4229V15.5442C17.6879 15.5442 19.8307 13.4002 19.8307 10.7663C19.8307 8.13126 17.6879 5.98849 15.0541 5.98849Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteProfileSettingsIcon);
export default __webpack_public_path__ + "static/media/WhiteProfileSettingsIcon.605996e34a9e4c7bceb89da518ce1fff.svg";
export { ForwardRef as ReactComponent };